import api from "./axios";

export const teamApi = {
  list: () => api.get("/teams").then((r) => r.data),
  get: (id: string) => api.get(`/teams/${id}`).then((r) => r.data),
  create: (data: { name: string; description?: string }) =>
    api.post("/teams", data).then((r) => r.data),
  update: (id: string, data: { name?: string; description?: string }) =>
    api.patch(`/teams/${id}`, data).then((r) => r.data),
  remove: (id: string) => api.delete(`/teams/${id}`),
  addMember: (id: string, userId: string) =>
    api.post(`/teams/${id}/members/${userId}`).then((r) => r.data),
  removeMember: (id: string, userId: string) =>
    api.delete(`/teams/${id}/members/${userId}`),
};
